import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { Box, Flex, Text, Image, Button } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import { Path } from 'config/constants/paths'
import { isAfter } from 'date-fns'

const endDate = new Date('2022-11-22T00:00:00Z')

export const isExpired = () => {
  return isAfter(new Date(), endDate)
}

const ECO_BOOST_POST_LAUNCH = true
const ECO_BOOST_MEDIUM_URL = 'https://medium.com/@ozzo_30385/f67e5b7b8a55'
export const storageKey = 'eco-boost'

const BANNER_TITLE = ECO_BOOST_POST_LAUNCH
  ? 'Cronos Ecosystem NFT Boost is Live'
  : 'Cronos Ecosystem NFT Boost is Coming'

const BANNER_SUBTITLE = ECO_BOOST_POST_LAUNCH
  ? 'Stake Argonauts to boost Argo-USDC & bCRO-CRO farms'
  : "Stake Cronos NFTs to boost respective farms' APRs"

const MOBILE_TITLE = ECO_BOOST_POST_LAUNCH ? 'Cronos Ecosystem NFT Boost is Live' : 'Coming Soon'
const MOBILE_SUBTITLE = ECO_BOOST_POST_LAUNCH ? 'Boost Argo-USDC & bCRO-CRO farms' : 'Cronos Ecosystem NFT Boost'

export const EcoBoostBanner = ({ onCloseClick }) => {
  const { t } = useTranslation()
  const routerHistory = useHistory()

  return (
    <EcoBoostBannerCard>
      {ECO_BOOST_POST_LAUNCH ? <ArgoIcon /> : <CronosIcon />}

      <ContentWrapper>
        <MobileTextsWrapper>
          <Text as="h3" color="white" fontSize="18px" fontWeight="700" mb="8px">
            {t(MOBILE_TITLE)}
          </Text>
          <Text as="p" color="white">
            {t(MOBILE_SUBTITLE)}
          </Text>
        </MobileTextsWrapper>
        <DesktopTextsWrapper>
          <BannerTitle as="h3" color="white" fontWeight="700">
            {t(BANNER_TITLE)}
          </BannerTitle>
          <Text as="p" color="white" fontSize="14px">
            {t(BANNER_SUBTITLE)}
          </Text>
        </DesktopTextsWrapper>
        <BtnsWrapper>
          {ECO_BOOST_POST_LAUNCH && <Button onClick={() => routerHistory.push(Path.VVS_FARM)}>{t('Boost')}</Button>}
          <LearnMoreBtn
            variant="secondary"
            color="white"
            href={ECO_BOOST_MEDIUM_URL}
            onClick={() => window.open(ECO_BOOST_MEDIUM_URL, '_blank')}
          >
            {t('Learn More')}
          </LearnMoreBtn>
        </BtnsWrapper>
      </ContentWrapper>

      <CloseImageButton
        height={22}
        width={22}
        src="/images/vvsMinerMole/close_button.png"
        alt="close"
        onClick={onCloseClick}
      />
    </EcoBoostBannerCard>
  )
}

const EcoBoostBannerCard = styled(Flex)`
  border-radius: ${({ theme }) => theme.radii.card};
  width: 100%;
  padding: 0px;
  max-width: 1200px;
  align-self: stretch;

  background: linear-gradient(90deg, #3f4e8b 0%, #2689c8 75.91%, #83dcdc 100%);
  position: relative;
  margin-top: 10px;
  margin-bottom: 28px;
  margin-left: 30px;
  margin-right: 30px;

  align-items: center;
  overflow: hidden;

  ${({ theme }) => theme.mediaQueries.md} {
    max-height: 120px;
  }
`

const ArgoIcon = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url('/images/ecoFarm/argonauts.png');
  background-repeat: no-repeat;
  pointer-events: none;

  background-position: 90% bottom;
  background-size: auto 96px;
  ${({ theme }) => theme.mediaQueries.md} {
    background-image: url('/images/ecoFarm/argo-vvs.png');
    background-position: 95% bottom;
    background-size: auto 64px;
  }
  ${({ theme }) => theme.mediaQueries.xxl} {
    background-size: auto 82px;
  }
`

const CronosIcon = styled.div`
  position: absolute;
  width: 119px;
  height: 119px;
  right: 5%;
  bottom: -28px;
  background-image: url('/images/cronos-icon.png');
  background-repeat: no-repeat;
  pointer-events: none;
  transform: rotate(-25deg);

  background-position: center center;
  background-size: auto 85%;

  ${({ theme }) => theme.mediaQueries.lg} {
    width: 140px;
    height: 140px;
    background-size: auto 100%;
  }
`
const ContentWrapper = styled(Flex)`
  flex: 1;
  align-self: stretch;
  padding: 20px 0 20px 30px;
  flex-direction: column;
  align-items: start;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 10px 30px;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    flex-direction: row;
    align-items: center;
    padding: 0 30px;
  }
`

const MobileTextsWrapper = styled(Box)`
  flex: 1;
  ${({ theme }) => theme.mediaQueries.sm} {
    display: none;
  }
`
const BtnsWrapper = styled(Flex)`
  z-index: 1;
  gap: 15px;

  & > button {
    padding: 0 16px;
  }
  ${({ theme }) => theme.mediaQueries.sm} {
    padding-right: 30px;
    & > button {
      height: 36px;
      padding: 0 12px;
    }
  }
  ${({ theme }) => theme.mediaQueries.md} {
    & > button {
      height: 48px;
      padding: 0 24px;
    }
  }
`
const DesktopTextsWrapper = styled(Box)`
  flex: 1;
  display: none;
  ${({ theme }) => theme.mediaQueries.sm} {
    display: block;
  }
  ${({ theme }) => theme.mediaQueries.xl} {
    order: 1;
    padding-bottom: 10px;
  }
`
const CloseImageButton = styled(Image)`
  margin-right: 15px;
  cursor: pointer;
`

const BannerTitle = styled(Text)`
  font-weight: 700;
  font-size: 18px;
  ${({ theme }) => theme.mediaQueries.xl} {
    font-size: 24px;
  }
`
const LearnMoreBtn = styled(Button)`
  color: white;
  border-color: white;
`
